import { createAsyncThunk } from "@reduxjs/toolkit";
import { updateCustomerDetails as updateCustomerDetailsApi } from "api/subscription";
import type { CustomerDetails } from "api/subscription/models/CustomerDetails";

export const updateCustomerDetails = createAsyncThunk<CustomerDetails, { userId: string; details: CustomerDetails }>(
  "customerDetails/update",
  async ({ userId, details }, thunkAPI) => {
    // Update API
    await updateCustomerDetailsApi(userId, details);
    // Return the details for Redux state
    return details;
  }
);
